export default ('ifLessOrEqual', function(valueOne, valueTwo, options) {
    if(valueOne <= valueTwo) {
        return options.fn(this);
    }
    return options.inverse(this);
});
